export const res = {
  error: {
    is: 'Óvænt villa varð í auðkenningu. Vinsamlegast reyndu aftur.',
    en: 'Unexpected error occurred during authentication. Please try again.',
    pl: 'W procesie identyfikacji wystąpił niespodziewany błąd. Prosimy spróbować jeszcze raz.',
  } as const,
  timeout: {
    is: 'Innskráning rann út á tíma',
    en: 'Log-in process timed out	',
    pl: 'Upłynął czas logowania',
  } as const,
};
